import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Linking } from "react-native";
import { styled, Container, ScrollView, View, Image, Text, P } from "dripsy";
import { Section, Button } from "../components";
import Logo from "../assets/logo.png";
var Description = styled(P, {
    defaultVariant: "text.secondary"
})();
var LogoImage = styled(Image)({
    width: 64,
    height: 64
});
var FEATURES = [
    "⚡️ Blazing Fast Build",
    "\uD83C\uDF33 Supports Tree Shaking",
    "\uD83D\uDCBE In-memory & Local File System Caching",
    "\uD83C\uDFA8 Flexible & Extensible",
    "\uD83D\uDD25 Supports JSC & Hermes Runtime",
    "\uD83D\uDD04 Supports Live Reload",
    "\uD83D\uDC1B Supports Debugging(Flipper, Chrome Debugger)",
    "\uD83C\uDF0D Supports All Platforms(Android, iOS, Web)",
    "✨ New Architecture Ready"
];
export function IntroScreen() {
    var handlePressGitHub = function() {
        Linking.openURL("https://github.com/leegeunhyeok/react-native-esbuild").catch(function() {
            return null;
        });
    };
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs(ScrollView, {
            children: [
                /*#__PURE__*/ _jsx(Section, {
                    children: /*#__PURE__*/ _jsx(LogoImage, {
                        source: Logo
                    })
                }),
                /*#__PURE__*/ _jsx(Section, {
                    title: "Features",
                    children: FEATURES.map(function(content, index) {
                        return /*#__PURE__*/ _jsx(Description, {
                            children: content
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsxs(Section, {
                    title: "Contribute",
                    children: [
                        /*#__PURE__*/ _jsx(Description, {
                            children: "Report bugs, request features, or anything"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            label: "GitHub",
                            onPress: handlePressGitHub
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Section, {
                    title: "Experimental",
                    children: [
                        /*#__PURE__*/ _jsx(Description, {
                            children: "This project is under development."
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            variant: "danger",
                            children: "CHECK & TEST BEFORE USING IN PRODUCTION"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    sx: {
                        marginBottom: "$04"
                    }
                })
            ]
        })
    });
}
